import { render, staticRenderFns } from "./ApplicationCounter.vue?vue&type=template&id=1d57e360&scoped=true"
import script from "./ApplicationCounter.vue?vue&type=script&lang=ts"
export * from "./ApplicationCounter.vue?vue&type=script&lang=ts"
import style0 from "./ApplicationCounter.vue?vue&type=style&index=0&id=1d57e360&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d57e360",
  null
  
)

export default component.exports